declare global {
  interface Window {
    WalkMeAPI: {
      startWalkthruById: (id: string) => void;
    };
  }
}
export interface IOverviewRecommendationsCardProps {
  i18n: {
    getString: (key: string, params?: any) => string;
  };
  perfMarkerUtils: {
    willFetchData: Function;
    willRender: Function;
    done: Function;
  };
  serverContext: {
    CurrentLocale: string;
  };
  permissions: any;
  navigationLevel: string;
  campaignType: number;
  legacyConfig: any;
  jsdata: object;
  featureInstrumentation: {
    addScenario: (schema: object) => void;
    loadRecommendationOverviewTile?: {
      create: () => {
        loadRecommendationOverviewTile: {
          create: () => {
            trace: (params: object, api: string) => void;
          };
        };
      };
    };
  },
  instrumentationConstants: any,
  instrumentationLegacy: any,
  constructOptions: ({
    navigationLevel,
    campaignType,
  }) => {
    entitySet: object,
    navigationLevel: string,
  };
  i18nErrors: object;
  preferencesService: any;
  locationMap: any;
  legacyRouter: any;
  walkme: any;
  adDisplayUrlService: any;
}

export interface ICoupon {
  rawData: {
    FeatureId: string,
  },
  value: number,
  tagMessage: string,
}

export interface ITip {
  tipId: string,
  type: string,
  tipName: string,
  helpType: string,
  isImportRelatedTip: boolean,
  imgClass: string,
  title: string,
  description: string,
  helpLink: string,
  coupon?: ICoupon,
}

export interface IRecommendation {
  category: string,
  type: string,
  recommendationsCount: number,
  opportunityCount: number,
  optimizationScore: number,
  version: number,
  helpType?: string,
  tipId?: string,
}

export type TActiveItem = ITip | IRecommendation;

export function isTip(item: TActiveItem): item is ITip {
  return (item as ITip).type === 'Tip';
}

export interface IScopeContext {
  scope: {
    save: Function;
    values: {
      aid: number;
      cid: number;
      uid: number;
      campaignId: number;
    }
  };
}
